export default __webpack_public_path__ + "c1232ec3f491db689df68e70aa1d773a.svg";